import type { Category } from './categories'

type PageType = 'recommendations' | 'noResults'

export const pageContent: Record<Category, Record<PageType, { content: string[] }>> = {
  laptops: {
    recommendations: {
      content: [
        "Based on what you've told us, we think these models are the best match for your needs.",
        "If you're not sure, you can view other laptops, or go back and change your choices.",
      ],
    },
    noResults: {
      content: [
        "We haven't found a perfect match based on your selections.",
        'Here are some articles to help you pick the right laptop based on our rigorous lab tests.',
      ],
    },
  },
  mattresses: {
    recommendations: {
      content: [
        "Based on what you've told us, we think these mattresses are the best match for your needs.",
        "If you're not sure, you can view other mattresses, or go back and change your choices.",
      ],
    },
    noResults: {
      content: [
        "We haven't found a perfect match based on your selections.",
        'Here are some articles to help you pick the right mattress based on our rigorous lab tests.',
      ],
    },
  },
}
